import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AlertController } from '@ionic/angular';
import { PatientAlertProvider } from '../patient-alert/patient-alert';
import { HistoryProvider } from '../history/history';
import { PatientDataProvider } from '../patient-data/patient-data';
import { OpenCaseProvider} from '../open-case/open-case';
import { Api } from '../api/api';
import { AlertEventsProvider } from '../alert-events/alert-events';
import { AlertData } from '../../interfaces/alert-data';
import { ModalPatientTabsPageComponent } from '../../shared/modals/modal-patient-tabs/modal-patient-tabs';
import { Logger } from 'ionic-logging-service';
import {BackgroundMode} from '@anuradev/capacitor-background-mode';
import {Events} from '../events';
import {PageController} from '../../page-controller/page.controller';
import {Page} from '../../page-controller/page.type';
import {ModalService} from '../modal.service';
import { AudioService } from '../audio/audio.service';


@Injectable()
export class SocketProvider {

  public openAlerts: any = {};
  private logger: Logger;
  //private incomingAlert: HTMLAudioElement;

  constructor(private alertEventsProvider: AlertEventsProvider, private patientAlertProvider: PatientAlertProvider, private pageController: PageController,
              private historyProvider: HistoryProvider, private patientDataProvider: PatientDataProvider, private openCaseProvider: OpenCaseProvider, private events: Events,
              private alertCtrl: AlertController, private api: Api, public translateService: TranslateService, private modalCtrl: ModalService,
              private audio: AudioService) {


      this.audio.preload('alertSound', 'notification.mp3');

      events.subscribe('switchSocket', () => {
      this.initAlertEvent();
      this.patientAlertProvider.addRefreshAlertData();
    });
  }

  private getLogger() {
    if(this.logger) {
      return this.logger;
    }

    return this.logger = this.api.getLogger('Hausnotruf.AlertEventsDataProvider');
  }

  async presentConfirm(_alertData: AlertData) {

    _alertData.editorPerson = this.patientDataProvider.api._user.profile.firstname + ' ' + this.patientDataProvider.api._user.profile.lastname;
    _alertData.notrufCallNumber = this.patientDataProvider.api._user.profile.callNumber;

    const active = (this.api.platform.is('capacitor')) ? await BackgroundMode.isActive() : {activated:false};

    console.log((active.activated+"*******************************************"));

    if (active.activated) {
      if (this.api.platform.is('android')) {
        console.log('hier'+"*******************************************");
        await BackgroundMode.wakeUp();
        await BackgroundMode.moveToForeground();
        await BackgroundMode.unlock();
      }
		}

    
    this.getLogger().info('input', { message: 'Alert Window open', alertData: _alertData });

    // Holt die Patentendaten mit der TransmitterID
    this.patientDataProvider.query({ transmitterId: _alertData.transmitterId }).subscribe({next:async (patientData: any) => {

      if (patientData && patientData.data.success) {
        if (typeof _alertData.location === 'undefined') {
          _alertData.location = '';
        }

        if (!_alertData.location && patientData.data.data.data.docs[0].management.locationDesc) {
          _alertData.location = patientData.data.data.data.docs[0].management.locationDesc;
        }

        _alertData.firstname = patientData.data.data.data.docs[0].addressData.firstname;
        _alertData.lastname = patientData.data.data.data.docs[0].addressData.lastname;

        this.openAlerts[_alertData.transmitterId] = await this.alertCtrl.create({
          header: this.translateService.instant('AlertInputDialog'),
          message: `<b>${patientData.data.data.data.docs[0].addressData.firstname} ${patientData.data.data.data.docs[0].addressData.lastname} </b><br>
          <hr>${_alertData.desc}<br>${_alertData.location}
          <hr>${this.translateService.instant('EditAlertNow')}`,
          cssClass: 'alert-danger',
          backdropDismiss: false,
          buttons: [
            {
              text: this.translateService.instant('NoAccept'),
              role: 'cancel',
              handler: () => {
                this.getLogger().info('action', { message: 'Alert click cancel', person: _alertData.editorPerson });
                this.audio.stop('alertSound');
                delete this.openAlerts[_alertData.transmitterId];
              }
            },
            {
              text: this.translateService.instant('YesAccept'),
              handler: () => {
                this.patientDataProvider.activePatientData = patientData.data.data.data.docs[0];

                this.audio.stop('alertSound');
                _alertData.editorPerson = this.patientDataProvider.api._user.profile.firstname + ' ' + this.patientDataProvider.api._user.profile.lastname;
                _alertData.notrufCallNumber = this.patientDataProvider.api._user.profile.callNumber;

                this.getLogger().info('action', { message: 'Alert click access', person: _alertData.editorPerson });

                this.openCaseProvider.setOpenCase(_alertData, false).then((res_alertData) => {

                  // Soll alle AlamFenster im anderen Browser schließen
                  //this.api.post('redButtonAlertCloseWindow', { body: _alertData });

                  // Remove Data from this.patientAlertProvider.alertData
                  // this.patientAlertProvider.alertData.splice(this.patientAlertProvider.alertData.indexOf(_alertData), 1);
                  this.patientAlertProvider.tableData.remove(_alertData);

                  _alertData = res_alertData;

                  _alertData.editorPerson = this.patientDataProvider.api._user.profile.firstname + ' ' + this.patientDataProvider.api._user.profile.lastname;
                  _alertData.notrufCallNumber = this.patientDataProvider.api._user.profile.callNumber;

                  this.patientAlertProvider.activeAlertData = _alertData;

                  // schreibe in die Patienten-History
                  this.historyProvider.openNewCase(_alertData, this.translateService.instant('CaseOpen'), '2222').then(async () => {

                    this.getLogger().info('openNewCase', { message: this.translateService.instant('CaseOpen'), transmitterId: _alertData.transmitterId });

                    // View-Array OpenCase füllen damit die Daten in der Tabelle angezeigt werden
                    this.openCaseProvider.add(_alertData);

                    // View Action
                    if (this.api.isBrowser || this.api.platform.is('tablet')) {
                      await this.pageController.navigateRoot(Page.Content);
                      this.events.publish('changeTabData');
                    } else {
                      await this.modalCtrl.openModal(ModalPatientTabsPageComponent);
                    }

                    if (this.patientDataProvider.activePatientData.management.deviceCall !== 'nein') {
                      // Startet den Rückruf Patient
                      this.patientAlertProvider.alertCallPatient(_alertData).subscribe({next:() => {
                        this.historyProvider.setHistoryData({
                          dateTime: new Date().getTime(),
                          code: '3333',
                          desc: this.translateService.instant('StartPatientCall'),
                          editorPerson: _alertData.editorPerson
                        });
                      }, error:(err) => {
                        this.getLogger().info('alertCallPatient', { message: err });

                        this.translateService.get(['Error', err.err.message, 'Close']).subscribe(async alert => {

                          const alertError = await this.alertCtrl.create({
                            header: alert.Error,
                            message: alert[err.err.message],
                            buttons: [alert.Close],
                            cssClass: 'alert-danger'
                          });
                          alertError.present();
                        });

                        this.historyProvider.setHistoryData({
                          dateTime: new Date().getTime(),
                          code: '9999',
                          desc: this.translateService.instant('ErrorPatientCall'),
                          editorPerson: _alertData.editorPerson
                        });
                      }});

                    }

                  });
                }, (err) => {
                  this.getLogger().error('setOpenCase', 'kann nich angelegt werden', { message: err });
                });
                delete this.openAlerts[_alertData.transmitterId];
              }
            }
          ]
        });
        
        console.log("***************************PLAY ALERT AUDIO********************");
        this.audio.loop('alertSound');

    
          if(this.openAlerts[_alertData.transmitterId]) {
            console.log("***************************alertWindow.present********************");
            await this.openAlerts[_alertData.transmitterId].present();
          } 
      

      }
      
    }, error: (err) => {
      this.getLogger().error('getPateientData', this.translateService.instant('PatientNotFound'), { message: err });
    }});

  }

  private async redButtonAlertCloseWindow(alertData: AlertData) {
    if (this.openAlerts[alertData.transmitterId]) {
      this.getLogger().info('redButtonAlertCloseWindow', { transmitterId: alertData.transmitterId, person: this.patientDataProvider.api._user.profile.firstname + ' ' + this.patientDataProvider.api._user.profile.lastname });
      await this.openAlerts[alertData.transmitterId].dismiss();
  
      console.log("**************AUDIO PAUSE**********");
      this.audio.stop('alertSound');
      delete this.openAlerts[alertData.transmitterId];
    }

    this.patientAlertProvider.tableData.getAll().then((data: Array<any>) => {
      const removeData = data.filter((obj) => obj.Uniqueid === alertData.Uniqueid);
      if (removeData.length) {
        this.patientAlertProvider.tableData.remove(removeData[0]);
      }
    });
  }

  private async hangup(hangupData) {
    const filter: any = this.patientAlertProvider.alertData.filter(obj => obj.Channel === hangupData.Channel);

    if (filter.length) {
      // this.patientAlertProvider.delete(filter[0]);
      if (this.openAlerts[filter[0].transmitterId]) {
        await this.openAlerts[filter[0].transmitterId].dismiss();
        delete this.openAlerts[filter[0].transmitterId];
      }
    }
  }

  private dialBegin(dialBeginData) {
    if(dialBeginData.ChannelStateDesc === "Up") {
      console.log("***************************DIAL BEGIN********************");
    }
  }

  private async inalert(alertData: any) {
    const alertGroups = await this.patientAlertProvider.checkAlertAccess(alertData.patientAlertGroups);

    if (alertGroups.length) {
      const _alertData = this.patientAlertProvider.socketPushAlert(alertData);
      this.alertEventsProvider.add(alertData);
      this.presentConfirm(_alertData);
    }
  }

  private technicalalert(alertData) {
    console.log('technicalalert', alertData);
  }

  private locationIsSet(data) {
    this.events.publish('set:Location', data);
  }

  initAlertEvent() {
    this.api.socket.removeAllListeners('redButtonAlertCloseWindow');
    this.api.socket.on('redButtonAlertCloseWindow', this.redButtonAlertCloseWindow.bind(this));

    /**
     * Die Verbindung zum Notrufgerät wurde getrennt
     */
    this.api.socket.removeAllListeners('incoming:hangup');
    this.api.socket.on('incoming:hangup', this.hangup.bind(this));

    this.api.socket.removeAllListeners('incoming:dialBegin');
    this.api.socket.on('incoming:dialBegin', this.dialBegin.bind(this));

    this.api.socket.removeAllListeners('incoming:alert');
    this.api.socket.on('incoming:alert', this.inalert.bind(this));

    this.api.socket.removeAllListeners('incoming:technicalalert');
    this.api.socket.on('incoming:technicalalert', this.technicalalert.bind(this));

    this.api.socket.removeAllListeners('set:Location');
    this.api.socket.on('set:Location', this.locationIsSet.bind(this));
  }

}
